import { TypedDocumentNode, gql } from "@apollo/client";

import { QuerySearchRunsSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";

type SearchStackTasksSuggestionsData = {
  searchRunsSuggestions: Pick<SearchSuggestionsOutput, "filteredCount">;
};

export const SEARCH_STACK_TASKS_SUGGESTIONS: TypedDocumentNode<
  SearchStackTasksSuggestionsData,
  QuerySearchRunsSuggestionsArgs
> = gql`
  query SearchStackTasksSuggestions($input: SearchSuggestionsInput!) {
    searchRunsSuggestions(input: $input) {
      filteredCount
    }
  }
`;
